/**
 * @prettier
 */

import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { ButtonV2 } from '@zola/zola-ui';
import Loader from 'components/common/ui/Loader';
import { fetchProject as fetchProjectAction } from 'cards/actions/projectActions';
import Layout from '../Layout/Layout';
import { getSingleSampleOrders } from '../util/api';
import SampleOrderTile from './SampleOrderTile';
import styles from './styles.module.less';

export const SampleLimitViewBase = ({
  text,
  cardType,
  fetchProject,
  closeModal,
  setModalOptions,
}) => {
  const [orderData, setOrderData] = useState(null);
  const [fetchedProjects, setFetchedProjects] = useState(null);

  useEffect(() => {
    setModalOptions({ preventClose: false, hideClose: false });
  }, []);

  useEffect(() => {
    getSingleSampleOrders(cardType).then(fetchedOrderData => {
      Promise.all(fetchedOrderData.map(data => fetchProject(data.projects[0].project_uuid))).then(
        fetchedProjs => {
          setOrderData(fetchedOrderData);
          setFetchedProjects(fetchedProjs);
        }
      );
    });
  }, [cardType]);

  if (orderData === null || fetchedProjects === null) {
    return <Loader />;
  }

  return (
    <div className={styles.box}>
      <Layout.Header>You&#39;re On a Roll</Layout.Header>
      <div className={styles.textBox}>
        <Layout.Text>{text}</Layout.Text>
      </div>
      <div className={styles.orderListingBox}>
        {orderData.map(
          (data, i) =>
            data && (
              <SampleOrderTile
                key={`${data.projects[0].project_uuid}--${i}`}
                createdAt={data.created_at}
                project={data.projects[0]}
                fetchedProject={fetchedProjects[i]}
              />
            )
        )}
      </div>
      <div className={styles.backButtonBox}>
        <ButtonV2 onClick={closeModal}>Go Back</ButtonV2>
      </div>
    </div>
  );
};

export const mapDispatchToProps = dispatch => ({
  fetchProject: projectUUID => dispatch(fetchProjectAction(projectUUID)),
});

export default connect(null, mapDispatchToProps)(SampleLimitViewBase);



// WEBPACK FOOTER //
// ./src/cards/components/common/SingleSample/SampleLimitView/SampleLimitView.jsx